/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'
import classes from 'classnames'
import { connect } from 'react-redux'

import { ui, routing } from '../redux'

const Sidebar = ({ children, isOpen, dispatch, title }) => (
    <div className="be-left-sidebar">
        <div className="left-sidebar-wrapper">
            <a
                className={ classes('left-sidebar-toggle', { open: isOpen }) }
                role="menuitem"
                onClick={ () => dispatch(ui.toggleMenu('mobileSidebar', ui.MENUS.dropdown)) }
            >
                { title }
            </a>
            <div className={ classes('left-sidebar-spacer', { open: isOpen }) }>
                <div className="left-sidebar-scroll">
                    <div className="left-sidebar-content">
                        { children }
                    </div>
                </div>
            </div>
        </div>
    </div>
)

Sidebar.propTypes = {
    isOpen   : PropTypes.bool,
    dispatch : PropTypes.func,
    title    : PropTypes.string
}

function mapStateToProps(state) {
    return {
        isOpen : ui.isMenuOpen('mobileSidebar', ui.MENUS.dropdown)(state),
        title  : routing.getPageTitle(state)
    }
}

export default connect(mapStateToProps)(Sidebar)
